export default __webpack_public_path__ + "static/media/editCircle.53afbca4.svg";